import { styled, Box } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: theme.spacing(1.25),
  margin: theme.spacing(8, 0),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(4, 0, 0, 0),
  },
  '& .LPChip': {
    flex: '0 0 auto',
    padding: theme.spacing(1, 0.75, 0.75, 0.75),
    backgroundColor: theme.palette.primary.main,
    borderRadius: theme.spacing(3),
    color: theme.palette.common.black,
    lineHeight: theme.spacing(1.75),
  },

  '& .LPParticipateText': {
    position: 'relative',
    top: theme.spacing(0.25),
    [theme.breakpoints.down('md')]: {
      fontSize: theme.spacing(1.5),
    },
  },
}));

export default StyledBox;
